module.exports = __webpack_public_path__ + "img/how-3.18e08e13.png";